import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { tx } from "../lib/ddd/ddd";
import { Helmet } from "react-helmet";
import classes from "./ObjectPlayground.module.scss";
import Button from "../components/UI/Button";
import GetNewInvoiceOptions from "../components/objectPlaygroundComponents/GetNewInvoiceOptions";
import { Container, Row, Col } from "react-bootstrap";
import SaveInvoiceOptions from "../components/objectPlaygroundComponents/SaveInvoiceOptions";
import { JsonEditor as Editor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";
import Response from "../components/objectPlaygroundComponents/Response";
import useWindowSize from "../hooks/useWindowSize";
import MobileVersion from "../components/mobileVersion/MobileVersion";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { diff } from "jsondiffpatch";
import LoadingDots from "../components/UI/LoadingDots";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ObjectPlayground = () => {
  const [chosenPartial, setChosenPartial] = useState("Normal");
  const [isInfoIncluded, setIsInfoIncluded] = useState(false);
  const [newInvoiceData, setNewInvoiceData] = useState(null); // data for the json editor
  const [validValues, setValidValues] = useState(null); // data for the form on the right
  const [isLoading, setIsLoading] = useState(false);
  const [isSavedLoading, setIsSavedLoading] = useState(null);
  const [saveInvRes, setSaveInvRes] = useState(null);
  const [saveInvReq, setSaveInvReq] = useState(null);
  const { width } = useWindowSize();
  const jsonEditorRef = useRef(null);
  
  useEffect(() => {
    if (jsonEditorRef.current) {
      const jsonEditorInstance = jsonEditorRef.current.jsonEditor;
      jsonEditorInstance.set(newInvoiceData);
    }
  }, [newInvoiceData]);

  function updateValueByKey(obj, key, index, newValue) {
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        if (prop === key) {
          obj[prop].Value = newValue;
          setValidValues(obj);
          const modifiedData = {
            Invoice: { ...newInvoiceData.Invoice, [prop]: newValue },
          };
          setNewInvoiceData(modifiedData);
          return;
        }
      }
    }
    for (let prop in obj["_details"]) {
      for (let subObj = 0; subObj < obj["_details"][prop].length; subObj++) {
        console.log("prop: " + prop);
        console.log("subobj: " + subObj);
        if (index) {
          subObj = index;
          console.log("afterwards subobj = " + subObj);
        }
        for (let subKey in obj["_details"][prop][subObj]) {
          if (subKey === key) {
            console.log("found a match!");
            obj["_details"][prop][subObj][subKey].Value = newValue;
            setValidValues(obj);
            const intermediateObj = {
              ...newInvoiceData.Invoice,
              _details: {
                ...newInvoiceData.Invoice["_details"],
                [prop]: [
                  ...newInvoiceData.Invoice["_details"][prop].slice(0, subObj),
                  {
                    ...newInvoiceData.Invoice["_details"][prop][subObj],
                    [subKey]: newValue,
                  },
                  ...newInvoiceData.Invoice["_details"][prop].slice(subObj + 1),
                ],
              },
            };
            const modifiedData = {
              Invoice: intermediateObj,
            };
            setNewInvoiceData(modifiedData);
            return;
          }
        }
      }
    }
  }

  const handleFieldChange = (fieldName, value, index) => updateValueByKey(validValues, fieldName, index, value);

  const handleEditorChange = (e) => {
    const spottedDif = diff(newInvoiceData.Invoice, e.Invoice);
    // console.log(spottedDif);
    let changedKey = Object.keys(spottedDif)[0];
    let newValue = spottedDif[changedKey][1];
    setNewInvoiceData(e);

    try {
      if (validValues.changedKey !== "undefined" && changedKey !== "_details") {
        setValidValues((prev) => ({
          ...prev,
          [changedKey]: {
            ...prev[changedKey],
            Value: newValue,
          },
        }));
      }
      if (changedKey === "_details") {
        let subItem = Object.keys(spottedDif["_details"])[0];
        let index = Object.keys(spottedDif["_details"][subItem])[0];
        let targetKey = Object.keys(spottedDif["_details"][subItem][index])[0];
        let newValue = spottedDif["_details"][subItem][index][targetKey][1];
        updateValueByKey(validValues, targetKey, index, newValue);
      }
    } catch (error) {
      console.log("An error occurred while updating the state:", error);
    }
  };

  const onChangePartialHandler = (partial) => setChosenPartial(partial);

  const onIncludeInfoCheckHandler = (e) => setIsInfoIncluded(e.target.checked);

  const onGetNewInvoice = () => {
    setIsLoading(true);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.DDDI_GetNew",
            args: {
              Complexity: chosenPartial,
              IncludeInfo: isInfoIncluded,
            },
          },
          id: 2,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        const invoiceObject = res.data.result.Result.Invoice;
        setNewInvoiceData(invoiceObject);

        axios
          .post(
            apiRequestAddress,
            {
              jsonrpc: "2.0",
              method: "Extension.Execute",
              params: {
                extension: "EUeInvoices.UI_Getnew",
                args: {
                  Complexity: chosenPartial,
                  EditableOnly: true,
                },
              },
              id: 52,
            },
            {
              withCredentials: true,
            }
          )
          .then((uiRes) => {
            console.log(uiRes);
            const validObject = uiRes.data.result.Result.Invoice;
            if (uiRes.data.result.Status.toLowerCase() === "ok") {
              setValidValues(validObject);
              setIsLoading(false);
              let newObj = JSON.parse(JSON.stringify(invoiceObject));
              for (const row in validObject) {
                if (newObj.Invoice[row] !== "undefined") {
                  newObj.Invoice[row] = validObject[row].Value;
                }
              }
            }
          });
      });
  };

  const onSaveInvoice = (steps, docs) => {
    setIsSavedLoading(true);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.DDDI_Save",
            args: {
              Complexity: chosenPartial,
              Object: newInvoiceData.Invoice,
              ReturnDoc: docs,
              Steps: steps,
            },
          },
          id: 3,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setSaveInvRes(res.data);
        let sentRequest =
          '{ method: "Extension.Execute", params: { extension: "EUeInvoices.DDD_SaveInvoice", args: { "Complexity": "' +
          { chosenPartial } +
          '", "Object": "' +
          JSON.stringify(newInvoiceData.Invoice) +
          '", "ReturnDoc": "' +
          { docs } +
          '", "Steps": "' +
          { steps } +
          '"} }';

        setSaveInvReq(sentRequest);
        setIsSavedLoading(false);
      });
  };

  const onAddNewItemHandler = (fieldName) => {
    let newValue = JSON.parse(
      JSON.stringify(validValues["_details"][fieldName][0])
    );
    let newValueJson = JSON.parse(
      JSON.stringify(newInvoiceData.Invoice["_details"][fieldName][0])
    );

    for (let prop in validValues["_details"]) {
      if (fieldName === prop) {
        console.log("a match: " + fieldName);
        let updatedValues = { ...validValues };
        updatedValues["_details"][prop].push(newValue);
        let updatedValuesJson = { ...newInvoiceData };
        updatedValuesJson.Invoice["_details"][prop].push(newValueJson);
        setValidValues(updatedValues);
        setNewInvoiceData(updatedValuesJson);
      }
    }
  };

  const renderFormField = (fieldName, fieldConfig, isDetail, index) => {
    const { Type, Mandatory, Value, ValidValues, Trans } = fieldConfig;

    const tooltip = (
      <Tooltip>{Trans && Trans.Tooltip ? Trans.Tooltip : ""}</Tooltip>
    );

    return (
      <div key={Math.random().toString()} className="w-100">
        {!isDetail && (
          <>
            <div>
              {/* <label>{fieldName}</label> */}
              <label>{fieldName || Trans.Title}</label>
              {Trans && Trans.Tooltip && (
                <OverlayTrigger
                  placement="left"
                  overlay={tooltip}
                  key={`overlay-trigger-${fieldName}`}
                >
                  <svg
                    width="12"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginLeft: "0.2rem" }}
                  >
                    <path
                      d="M9.41656 1.4125C4.99542 1.4125 1.4125 4.9953 1.4125 9.41656C1.4125 13.8377 4.9953 17.4206 9.41656 17.4206C13.8377 17.4206 17.4206 13.8378 17.4206 9.41656C17.4206 4.99542 13.8378 1.4125 9.41656 1.4125ZM9.41656 0C14.6182 0 18.8331 4.21572 18.8331 9.41656C18.8331 14.6182 14.6174 18.8331 9.41656 18.8331C4.21491 18.8331 0 14.6174 0 9.41656C0 4.21491 4.21572 0 9.41656 0Z"
                      fill="#00436D"
                    />
                    <path
                      d="M9.88754 11.3001C9.88754 11.6901 9.5713 12.0063 9.18128 12.0063C8.79111 12.0063 8.47503 11.6901 8.47503 11.3001V10.9432C8.47503 9.9224 8.93946 9.39319 9.96462 8.79603C9.93876 8.811 10.2641 8.62309 10.3494 8.57217C11.2145 8.05604 11.5354 7.60783 11.5354 6.57117C11.5354 5.40461 10.7235 4.6542 9.18129 4.6542C7.77117 4.6542 6.82701 5.74575 6.82701 7.00832C6.82701 7.39834 6.51093 7.71458 6.12076 7.71458C5.73074 7.71458 5.41451 7.39834 5.41451 7.00832C5.41451 5.00749 6.94179 3.2417 9.18129 3.2417C11.4798 3.2417 12.9479 4.59855 12.9479 6.57117C12.9479 8.17082 12.3281 9.03628 11.0734 9.78511C10.9778 9.84218 10.6414 10.0364 10.6756 10.0165C10.0417 10.3857 9.88756 10.5615 9.88756 10.9432L9.88754 11.3001ZM9.13415 15.0667C8.61406 15.0667 8.19253 14.6452 8.19253 14.1251C8.19253 13.605 8.61406 13.1833 9.13415 13.1833C9.65423 13.1833 10.0758 13.605 10.0758 14.1251C10.0758 14.6452 9.65423 15.0667 9.13415 15.0667Z"
                      fill="#00436D"
                    />
                  </svg>
                </OverlayTrigger>
              )}
            </div>
            {ValidValues === undefined && fieldName !== "_details" && (
              <input
                type={Type}
                defaultValue={Value ? Value : ""}
                name={fieldName}
                required={Mandatory}
                onBlur={(e) =>
                  handleFieldChange(fieldName, e.target.value, index)
                }
                placeholder={
                  (Trans !== undefined ? Trans.Placeholder : "") || ""
                }
              />
            )}
            {ValidValues && ValidValues.length > 0 && (
              <select
                name={fieldName}
                id={Math.random().toString()}
                onChange={(e) =>
                  handleFieldChange(fieldName, e.target.value, index)
                }
                value={validValues[fieldName].Value || ""}
              >
                {ValidValues.map((value, index) => (
                  <option value={value.Code} key={index}>
                    {value.Code}
                  </option>
                ))}
              </select>
            )}
          </>
        )}
        {isDetail && (
          <div style={{ marginLeft: 50 / 16 + "rem" }} className="w-100">
            <div>
              <label>{fieldName}</label>
              {Trans && Trans.Tooltip && (
                <OverlayTrigger
                  placement="left"
                  overlay={tooltip}
                  key={`overlay-trigger-${fieldName}`}
                >
                  <svg
                    width="12"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginLeft: "0.2rem" }}
                  >
                    <path
                      d="M9.41656 1.4125C4.99542 1.4125 1.4125 4.9953 1.4125 9.41656C1.4125 13.8377 4.9953 17.4206 9.41656 17.4206C13.8377 17.4206 17.4206 13.8378 17.4206 9.41656C17.4206 4.99542 13.8378 1.4125 9.41656 1.4125ZM9.41656 0C14.6182 0 18.8331 4.21572 18.8331 9.41656C18.8331 14.6182 14.6174 18.8331 9.41656 18.8331C4.21491 18.8331 0 14.6174 0 9.41656C0 4.21491 4.21572 0 9.41656 0Z"
                      fill="#00436D"
                    />
                    <path
                      d="M9.88754 11.3001C9.88754 11.6901 9.5713 12.0063 9.18128 12.0063C8.79111 12.0063 8.47503 11.6901 8.47503 11.3001V10.9432C8.47503 9.9224 8.93946 9.39319 9.96462 8.79603C9.93876 8.811 10.2641 8.62309 10.3494 8.57217C11.2145 8.05604 11.5354 7.60783 11.5354 6.57117C11.5354 5.40461 10.7235 4.6542 9.18129 4.6542C7.77117 4.6542 6.82701 5.74575 6.82701 7.00832C6.82701 7.39834 6.51093 7.71458 6.12076 7.71458C5.73074 7.71458 5.41451 7.39834 5.41451 7.00832C5.41451 5.00749 6.94179 3.2417 9.18129 3.2417C11.4798 3.2417 12.9479 4.59855 12.9479 6.57117C12.9479 8.17082 12.3281 9.03628 11.0734 9.78511C10.9778 9.84218 10.6414 10.0364 10.6756 10.0165C10.0417 10.3857 9.88756 10.5615 9.88756 10.9432L9.88754 11.3001ZM9.13415 15.0667C8.61406 15.0667 8.19253 14.6452 8.19253 14.1251C8.19253 13.605 8.61406 13.1833 9.13415 13.1833C9.65423 13.1833 10.0758 13.605 10.0758 14.1251C10.0758 14.6452 9.65423 15.0667 9.13415 15.0667Z"
                      fill="#00436D"
                    />
                  </svg>
                </OverlayTrigger>
              )}
              <button
                className={classes.addBtn}
                onClick={() => onAddNewItemHandler(fieldName)}
                type="button"
              >
                +
              </button>
            </div>
            {fieldConfig.map((item, theRightIndexIGuess) => (
              <div
                style={{ paddingLeft: 55 / 16 + "rem" }}
                className={`${classes.subObject} w-100`}
              >
                {Object.entries(item).map(
                  ([labelName, fieldValue], itemIndex) => {
                    if (fieldValue.Editable) {
                      if (fieldValue.ValidValues === undefined) {
                        return (
                          <div>
                            <label>{labelName}</label>
                            <input
                              type={fieldValue.Type}
                              onBlur={(e) =>
                                handleFieldChange(
                                  labelName,
                                  e.target.value,
                                  theRightIndexIGuess
                                )
                              }
                              defaultValue={fieldValue.Value}
                            />
                          </div>
                        );
                      } else {
                        // console.log(fieldValue.ValidValues);
                        return (
                          <div>
                            <label>{labelName}</label>
                            <select
                              // name={fieldName}
                              id={Math.random().toString()}
                              onChange={(e) =>
                                handleFieldChange(
                                  labelName,
                                  e.target.value,
                                  theRightIndexIGuess
                                )
                              }
                              value={fieldValue.Value || ""}
                            >
                              {fieldValue.ValidValues.map((value, index) => (
                                <option value={value.Code} key={index}>
                                  {value.Code}
                                </option>
                              ))}
                            </select>
                          </div>
                        );
                      }
                    } else return <></>;
                  }
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>Object Playground | DDD Invoices</title>
      </Helmet>
      {width > 768 && (
        <div className={`w-100 p-5 ${classes.container}`}>
          <Row>
            <Col className="col-6 pe-3">
              <Container className="d-flex flex-column h-100">
                <Row>
                  <Col className="d-flex justify-content-between align-items-end">
                    <GetNewInvoiceOptions
                      onChangePartialHandler={onChangePartialHandler}
                      chosenPartial={chosenPartial}
                      onIncludeInfoCheckHandler={onIncludeInfoCheckHandler}
                    />
                    <Button
                      className="px-lg-5 mt-3 w-100 py-1"
                      onClick={onGetNewInvoice}
                    >
                      {tx("DDDI_GetNew")}
                    </Button>
                  </Col>
                </Row>
                <Row style={{ flex: 1 }}>
                  <Col
                    className="d-flex"
                    style={{ maxHeight: "calc(66vh - 64px)" }}
                  >
                    {newInvoiceData && !isLoading && (
                      <div className={classes["new-invoice-response"]}>
                        <div className={classes["editor-wrapper"]}>
                          <Editor
                            // mode="code"
                            mode={Editor.modes.code}
                            allowedModes={["code", "tree"]}
                            value={newInvoiceData}
                            // value={validValues}
                            // onChange={(data) => setNewInvoiceData(data)}
                            // onChange={(data) => handleEditorChange(data)}
                            onChange={handleEditorChange}
                            ref={jsonEditorRef}
                          />
                        </div>
                      </div>
                    )}
                    {isLoading && !newInvoiceData && !validValues && (
                      <LoadingDots />
                    )}
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col className="col-6">
              {validValues && !isLoading && (
                <div className={classes["form-wrapper"]}>
                  <form>
                    {Object.entries(validValues).map(
                      ([fieldName, fieldConfig]) =>
                        renderFormField(fieldName, fieldConfig, false, null)
                    )}
                    {Object.entries(validValues["_details"]).map(
                      ([fieldName, fieldConfig]) =>
                        renderFormField(fieldName, fieldConfig, true, null)
                    )}
                  </form>
                </div>
              )}
            </Col>
          </Row>
          <Row className="mt-4">
            <Col className="col-6 pe-3" style={{ maxHeight: "66vh" }}>
              {newInvoiceData && !isLoading && (
                <SaveInvoiceOptions onPassData={onSaveInvoice} />
              )}
            </Col>
            <Col className="col-6">
              {isSavedLoading && <LoadingDots />}
              {!isSavedLoading && saveInvRes && (
                <Response response={saveInvRes} request={saveInvReq} />
              )}
            </Col>
          </Row>
        </div>
      )}
      {width <= 768 && <MobileVersion />}
    </>
  );
};

export default ObjectPlayground;
